import { useState, useEffect } from 'react'
import { CABLE_CONNECTION_URL } from 'env'

import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useSuperAdmin } from 'hooks/useSuperAdmin'
import { useHeaders } from 'hooks/useHeaders'

import { useSelector } from 'react-redux'
import isEqual from 'lodash/isEqual'
import { RootState } from 'types'

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const useWebsocketUrl = (cableConnectionUrl: string = CABLE_CONNECTION_URL!) => {
  // NOTE: in theory, we should not instantiate a websocket connection if there isn't
  // some sort of auth: either user, unregistered, anonymous, etc.
  //
  // However, the code in useWebsocketConnection sets the default url as CABLE_CONNECTION_URL
  // and for some reason, on page load, there is _always_ some sort of auth, meaning
  // that the connection is _always_ instanciated, and never nullified
  // (since useWebsocketConnection#L54 does not dispatch null - keeps prev value)
  // So for now, this hook is only extracting behavior from useWebsocketConnection and
  // not trying to "fix" it, because it then breaks elsewhere (where it is assumed that
  // there is always a websocket connection)
  //
  // In fact, we should probably always have a sort of auth, if we weren't relying on
  // redux and its async nature, we could probably ensure that `connectionUrl` is
  // always a string with auth (either user or anon/unregistered).
  // But again, this is a bigger refactor than this extraction.
  const [connectionUrl, setConnectionUrl] = useState<string>(cableConnectionUrl)
  const headers = useHeaders()
  const currentWorkspaceId = useCurrentWorkspaceId()
  const { superAdminMode } = useSuperAdmin()

  const { unregisteredUser } = useSelector(({ unregisteredUser }: RootState) => ({ unregisteredUser }), isEqual)

  const authHeader = headers || unregisteredUser?.headers

  useEffect(() => {
    const jwt = authHeader?.authorization?.split(' ')[1]

    if (jwt) {
      const query = new URLSearchParams({
        jwt,
        current_workspace_id: currentWorkspaceId.toString(),
        super_admin_workspace_id: (superAdminMode && currentWorkspaceId.toString()) || '',
      })

      setConnectionUrl(`${cableConnectionUrl}?${query}`)
    } else {
      // NOTE: follow up of NOTE above, in theory this is a state that should never happen
      // or at least we should nullify.
      setConnectionUrl(cableConnectionUrl)
    }
  }, [authHeader?.authorization, currentWorkspaceId, superAdminMode, cableConnectionUrl])

  return {
    connectionUrl,
  }
}
